export default __webpack_public_path__ + "static/media/youtube.b082052d.png";